// src/components/UserMenu.jsx

import React, { useState, useRef, useEffect } from "react";
import { FaUserCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useActiveModule } from "./ActiveModuleContext"; // 🔹 Importamos contexto

export default function UserMenu() {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  // 🔹 Obtenemos activeModule y setActiveModule desde el contexto
  const { setActiveModule } = useActiveModule();

  // 🔹 Detectar clics fuera del menú
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // 🔹 Cerrar sesión
  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token");
      console.log("Cerrando sesión...");
      await fetch("/api/logout", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Sesión cerrada exitosamente.");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    } catch (error) {
      console.error("Error al cerrar sesión", error);
    }
  };

  // 🔹 Ir al módulo de edición de usuario
  const goToProfile = () => {
    setActiveModule("EditarPerfil"); // 🔹 Cambiamos el módulo activo
    setMenuOpen(false); // 🔹 Cerramos el menú
  };

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setMenuOpen(!menuOpen)}
        className="flex items-center gap-2 focus:outline-none"
      >
        <FaUserCircle className="text-2xl text-white" />
        <span className="font-medium text-white">
          {`${JSON.parse(localStorage.getItem("user"))?.nombre || "Usuario"} ${JSON.parse(localStorage.getItem("user"))?.apellido || ""}`}
        </span>
      </button>

      {menuOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white shadow-md rounded-md overflow-hidden text-gray-700 z-50">
          <button
            onClick={goToProfile} // 🔹 Cambia módulo a EditarPerfil
            className="w-full text-left px-4 py-2 hover:bg-gray-100"
          >
            Editar Perfil
          </button>
          <button
            onClick={handleLogout}
            className="w-full text-left px-4 py-2 hover:bg-gray-100"
          >
            Cerrar Sesión
          </button>
        </div>
      )}
    </div>
  );
}
